import { createContext, useContext, useRef, useState } from "react";
import { AlertDialog } from "./AlertDialog";

const AlertServiceContext = createContext(Promise.reject);

export const useAlert = () => useContext(AlertServiceContext);

export const AlertServiceProvider = ({ children }) => {
  const [alertState, setAlertState] = useState(null);

  const awaitingPromiseRef = useRef();

  const openAlert = (options) => {
    setAlertState(options);
    return new Promise((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  };

  const handleClose = () => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }

    setAlertState(null);
  };

  return (
    <>
      <AlertServiceContext.Provider value={openAlert} children={children} />

      <AlertDialog
        open={Boolean(alertState)}
        onClose={handleClose}
        {...alertState}
      />
    </>
  );
};
